// Úložiště celých samolepek s AI v prohlížeči zákazníka (IndexedDB – jedna šablona má kolem 1 MB,
// localStorage by stačil jen na pár kusů). Při chybě IndexedDB zůstanou šablony jen v paměti.
import type { CustomTemplate } from '../types';
import { AI_TEMPLATES_KEY } from './aiSticker';

const DB = 'samolepky-ai';
const STORE = 'kv';
const KEY = 'templates';
export const MAX_LOCAL_TEMPLATES = 24;

function open(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const r = indexedDB.open(DB, 1);
    r.onupgradeneeded = () => { r.result.createObjectStore(STORE); };
    r.onsuccess = () => resolve(r.result);
    r.onerror = () => reject(r.error);
  });
}

export async function loadLocalTemplates(): Promise<CustomTemplate[]> {
  let list: CustomTemplate[] = [];
  try {
    const db = await open();
    list = await new Promise<CustomTemplate[]>((resolve, reject) => {
      const q = db.transaction(STORE, 'readonly').objectStore(STORE).get(KEY);
      q.onsuccess = () => resolve(Array.isArray(q.result) ? q.result : []);
      q.onerror = () => reject(q.error);
    });
  } catch { /* bez IndexedDB */ }
  // převzetí starších šablon z localStorage (první verze)
  try {
    const legacy = JSON.parse(localStorage.getItem(AI_TEMPLATES_KEY) || '[]') as CustomTemplate[];
    if (legacy.length) {
      const ids = new Set(list.map(t => t.id));
      list = [...legacy.filter(t => t && t.id && t.data && !ids.has(t.id)), ...list].slice(-MAX_LOCAL_TEMPLATES);
      await saveLocalTemplates(list);
      localStorage.removeItem(AI_TEMPLATES_KEY);
    }
  } catch { /* nic */ }
  return list.filter(t => t && t.id && t.data).map(t => ({ ...t, isLocal: true }));
}

export async function saveLocalTemplates(list: CustomTemplate[]): Promise<void> {
  try {
    const db = await open();
    await new Promise<void>((resolve, reject) => {
      const tx = db.transaction(STORE, 'readwrite');
      tx.objectStore(STORE).put(list.slice(-MAX_LOCAL_TEMPLATES), KEY);
      tx.oncomplete = () => resolve();
      tx.onerror = () => reject(tx.error);
    });
  } catch { /* zůstane jen v paměti */ }
}
